<template lang="pug">
.map-app__itinerary-node
    header.map-app__header.col-12
        p: router-link(
            to="/highlight"
        ).map-app__header__breadcrumb
            //- img(src="../static/chevron-left.svg").chevron-left
            ChevronLeft.chevron-left
            | {{ title }}
        h2 {{ highlightsArr.name }}
    .map-app__itinerary-node-body
        .map-app__itinerary-node-number(v-if="imageLink")
            | {{ id }}
        img(
            :src="imageLink"
            v-if="imageLink"
        )
        .map-app__itinerary-node-text(v-html="description")
        .map-app__itinerary-node-buttons
            ul
                li(
                    v-if="button1Url"
                    :style="!button2Url ? {'width': '100%'}: ''"
                )
                    a(
                        :href="button1Url"
                        :class="`o-btn o-btn--large btn ${button1Style}`"
                    ) {{ button1Text }}
                li(
                    v-if="button2Url"
                )
                    a(
                        :href="button2Url"
                        :class="`o-btn o-btn--large btn ${button2Style}`"
                    ) {{ button2Text }}
    .map-app__itinerary-node-footer-nav
        ul
            li
                button(
                    @click="clickHandler('prev')"
                ) Prev
            li 
                button(
                    @click="clickHandler('next')"
                ) Next

</template>

<script>
import ChevronLeft from '../static/chevron-left.svg'

export default {
    name: 'itinerary-node',
    props: ['data', 'route'],
    data() {
        return {
            highlightsArr: [],
            title: '',
            description: '',
            imageLink: '',
            id: 0,
            next: '',
            prev: '',
            button1Url: '',
            button1Style: '',
            button1Text: '',
            button2Url: '',
            button2Style: '',
            button2Text: '',
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {
            this.title = this.data.title
            this.highlightsArr = this.setObj(this.data.highlightsArr, this.$route.params.node)
            this.description = this.highlightsArr.description
            this.id = this.highlightsArr.id
            this.next = this.getLink(this.data, this.id, 'next')
            this.prev = this.getLink(this.data, this.id, 'prev')

            // buttons
            this.button1Style = this.highlightsArr.button1Style ? this.highlightsArr.button1Style : ''
            this.button1Url = this.highlightsArr.button1Url ? this.highlightsArr.button1Url : ''
            this.button1Text = this.highlightsArr.button1Text ? this.highlightsArr.button1Text : ''
            this.button2Style = this.highlightsArr.button2Style ? this.highlightsArr.button2Style : ''
            this.button2Url = this.highlightsArr.button2Url ? this.highlightsArr.button2Url : ''
            this.button2Text = this.highlightsArr.button2Text ? this.highlightsArr.button2Text : ''
            
            this.$root.$emit('itinerary-node-active', this.highlightsArr)
        },
        getLink(obj, id, step) {
            let arr = obj.highlightsArr
            let length = obj.highlightsArr.length
            let newId = step == 'next' ? id + 1 : id - 1
            
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].id == newId) {
                    return arr[i].link
                }
            }
            if( step == 'next') {
                return arr[0].link
            } else {
                return arr[arr.length - 1].link
            }
        },
        setObj(arr, value) {
            let obj
            for(let i = 0; i < arr.length; i++ ) {
                obj = arr[i]
                for (let a in obj) {
                    if (obj.hasOwnProperty(a) && obj[a] == value) {
                        return obj
                    }
                }
            }
        },
        getImageLink() {
            let obj = this.highlightsArr
            this.imageLink =  this.removeTilde(Object.entries(obj).length === 0 && obj.constructor === Object ? '' : this.highlightsArr.imageLink)
        },
        clickHandler(command) {
            if(command == 'next') {
                this.$router.push(`/highlight/${this.next}`)
            } else {
                this.$router.push(`/highlight/${this.prev}`)
            }
        },
        removeTilde(str) {
            let url = str
            if (str.includes('~')) {
                url = str.replace('~', '')
            }
            return url
        },
    },
    watch: {
        highlightsArr() {
            this.getImageLink()
        },
        $route() {
            this.initData()
        },
    },
    components: {
        ChevronLeft,
    },
}
</script>

<style lang="scss">
@import "../scss/variables";

.map-app__itinerary-node {
    position: absolute;
    width: 100%;
    height: 83%;
    top: 0;
    background: $white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: 767px) {
        height: 100%;
        justify-content: flex-start;
    }

    .map-app__header {
        border-bottom: 1px solid $grey2;
        flex: 0 1 auto;
    }

    &-body {
        position: relative;
        padding: 1rem 2rem 5rem;
        counter-reset: count;
        flex: 0 1 auto;
        height: 80%;
        overflow: auto;

        img {
            width: 100%;
            padding-bottom: 1rem;
        }
    }

    &-number {
        position: absolute;
        padding: 1.5rem;
        top: 0.5rem;
        left: 0.5rem;
        color: $white;
        border-radius: 50%;
        background-color: $red;
        width: 24px;
        height: 24px;
        font-weight: bold;
        margin-right: 1em;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 3px solid $white;
    }

    &-buttons {
        ul {
            list-style: none;
            display: flex;
            flex-direction: row;
            padding: 1rem 0;
            margin: 0;

            li {
                margin: 0 0.25rem 0 0;
                width: 50%;

                &:last-child {
                    margin: 0 0 0 0.25rem;
                }

                a {
                    font-size: 1rem;
                    width: 100%;
                    padding: 10px;
                }
            }

        }
    }

    &-footer-nav {
        position: absolute;
        width: 100%;
        bottom: 0;
        background-color: $white;
        box-shadow: 3px 0 5px rgba(0, 0, 0, 0.25);

        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 5px;
            background: white;
        }

        ul {
            list-style: none;
            display: flex;
            flex-direction: row;
            padding: 1rem;
            margin: 0;

            li {
                margin: 0 0.5rem;
                width: 50%;

                button {
                    font-size: 1rem;
                    width: 100%;
                    padding: 10px;
                    border: 1px solid #E2E2E2;
                    border-radius: 4px;
                    background-color: $grey1;
                    color: $black;
                    outline: none;
                    transition: background-color 0.05s;

                    &:active {
                        background-color: $grey2;
                    }
                }
            }

        }
    }
}
</style>